<template>
    <div class="shipping_conf">
        <h3 class="text-center">{{ $t('page.shipping.ShipperEdit') }}</h3>
        <div class="form-group row">
            <label class="col-md-4 control-label">{{ $t('page.shipping.shipper') }}</label>
            <div class="col-md-7 inputGroupContainer">
                <div class="input-group">
                    <span class="input-group-addon"></span>
                    <input type="text" class="form-control" v-model="shipper.name">
                </div>
            </div>
        </div>
        <div class="form-group row btn-to-right">
            <button class="btn btn-primary" @click="submit()">{{ $t('page.shipping.save') }}</button>
        </div>


    </div>
</template>

<script>
    import shipperService from "../../services/shipperService";
    import shippingMethodService from "../../services/shippingMethodService";

    export default {
        name: "ProviderEdit",
        props: [
            'shippingProviderID',
        ],
        data() {
            return {
                shipper: {
                    name: null
                }
            }
        },
        methods: {
            getShipper() {
                shipperService.get(this.shippingProviderID).then(
                    (response) => {
                        this.shipper = response;
                    });
            },
            isCreated(shipper) {
                if (this.shippingProviderID == null) {
                    shipperService.create(this.shipper);
                } else {
                    shipperService.update(this.shippingProviderID, shipper);
                }
            },
            submit() {
                this.isCreated(this.shipper);
                this.$eventBus.$emit('provider-create-edit');
            }
        },
        mounted() {
            this.getShipper();
        }
    }
</script>

<style scoped>

</style>